import { useSiteMedia } from "@/context/SiteMediaContext";
import { useEffect, useState } from "react";
import { TreatmentRow } from "../../components/public/TreatmentRow";
import { useLanguage } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";


export default function Treatments() {
  const media = useSiteMedia();
  const { T } = useLanguage();
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/public/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-20" data-testid="treatments-page">
      <section className="relative h-[45vh] lg:h-[55vh]">
        <img src={media.treatments_banner} alt="Tratamentos" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#090708]/30 flex flex-col items-start justify-end p-6 lg:p-16">
          <p className="text-[11px] tracking-[0.25em] uppercase text-[#E8C47A] mb-3">{T.treatments.eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F7F0E8] mb-2">{T.treatments.page_title}</h1>
          <p className="text-sm text-[#F7F0E8]/70 max-w-sm">{T.treatments.page_subtitle}</p>
        </div>
      </section>
      <section className="px-6 lg:px-16 py-16 max-w-[1600px] mx-auto">
        <div className="flex flex-col divide-y divide-[#090708]/8">
          {services.map((s, i) => <TreatmentRow key={s.id} service={s} index={i} />)}
        </div>
      </section>
    </div>
  );
}
